export default[
    {
        name: 'Registration',
        path: 'Registration',
        component: () => import('@/pages/Copyright/Registration'),
        meta: { title: '作品登记' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        }
    },
    {
        name: 'RightsProtection',
        path: 'RightsProtection',
        component: () => import('@/pages/Copyright/RightsProtection'),
        meta: { title: '作品维权' },
        // props值为函数，该函数返回的对象中每一组key-value都会通过props传给Detail组件
        props(route) {
            return {
                id: route.query.id,
            }
        }
    }
]